import { Http } from '../../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    page: 1,
    search: '',
  },
  result: undefined,
  error: undefined,
  pagination: {
    limit: 25,
  },
};

const change = (store, data) => {
  store.setState((state) => {
    state.admin.reportes.facturacion.xml_storage = {
      ...state.admin.reportes.facturacion.xml_storage,
      data: {
        ...state.admin.reportes.facturacion.xml_storage.data,
        ...data,
      },
    };
  });
};

const paginate = async (store, meta) => {
  store.setState((state) => {
    state.admin.reportes.facturacion.xml_storage = {
      ...state.admin.reportes.facturacion.xml_storage,
      busy: true,
      filters: {
        ...state.admin.reportes.facturacion.xml_storage.filters,
        ...meta,
      },
      pagination: {
        ...state.admin.reportes.facturacion.xml_storage.pagination,
        limit: meta?.limit ?? 25,
      },
    };
  });

  try {
    const { pagination } = store.state.admin.reportes.facturacion.xml_storage;
    const params = {
      ...meta,
      limit: pagination.limit,
    };

    const response = await Http.get(`/app/admin/reportes/storage`, { params });

    store.setState((state) => {
      state.admin.reportes.facturacion.xml_storage = {
        ...state.admin.reportes.facturacion.xml_storage,
        busy: false,
        data: response.data,
        pagination: {
          ...state.admin.reportes.facturacion.xml_storage.pagination,
          ...response.meta.pagination,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.admin.reportes.facturacion.xml_storage.busy = false;
      state.admin.reportes.facturacion.xml_storage.error = error.data || error;
    });
  }
};

const updateFilters = (store, filters) => {
  store.setState((state) => {
    state.admin.reportes.facturacion.xml_storage.filters = {
      ...state.admin.reportes.facturacion.xml_storage.filters,
      ...filters,
    };
  });
};

const reset = (store) => {
  store.setState((state) => {
    state.admin.reportes.facturacion.xml_storage = {
      ...initialState,
    };
  });
};

const ReporteFacturacionXmlStampingStoragetore = {
  state: () => initialState,
  actions: {
    change,
    paginate,
    reset,
    updateFilters,
  },
};

export default ReporteFacturacionXmlStampingStoragetore;
